/**
 * Vip Level Replacer Model
 */

define(function(require, exports, module) {
    'use strict';
    var $ = require('j'),
        BaseModel = require('common/base.model'),
        server = require('server'),
        user = require('user');

    module.exports = BaseModel.extend({

        /**
         * Server request status
         * @type {Deferred}
         */
        process: null,

        sync: function(method, model, options) {
            if (method === 'read') {
                return this.getVipLevel(model, options);
            }
        },

        parse: function(response) {
            user.get('userDetails').vipLevel = response.data.vipLevel;
        },

        getVipLevel: function(model, options) {
            var def = $.Deferred(),
                request = {
                    ID: 31082,
                    responses: [31083],
                    description: 'Get Player VIP level',
                    requestType: 'marked',
                    requestedPlayerData: [1, 2, 31]
                };

            if (this.process && this.process.state() === 'pending') {
                return this.process;
            } else if (user.get('userDetails').vipLevel) {
                def.resolve();
            } else {
                return this.process = server.send(request)
                    .done(options.success)
                    .fail(options.error);
            }

            return def.promise();
        },

        /**
         * Override clear method (remove process)
         */
        clear: function() {
            this.process = null;

            return BaseModel.prototype.clear.call(this);
        }

    });

});